import { createReducer } from '@src/redux/helpers/createReducer';
import { apiList } from '@src/app/constants/apiList';
import {
  DESIGNATE_PAA,
  SET_PHONE_NUMBER,
  RESET_STATE,
  SET_JOB_FUNCTIONS,
  SET_API_LIST,
  SET_SELF_ATTESTATION_DONE,
  SET_API_USE_TEXT,
  SET_SELECTED_API_CODES,
  SUBMIT_TIN_REQUEST,
} from './constants';

const initialState = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  phoneExt: '',
  selectedJobFunctions: null,
  apiListSelection: apiList,
  apiUseText: '',
  attested: false,
  selectedApiCodes: [],
  designatePAASaga: { isLoading: false, isError: false, isSuccess: false },
  submitPATINSaga: { isLoading: false, isError: false, isSuccess: false },
};

export const PAARegistrationReducer = createReducer(initialState, {
  [`${DESIGNATE_PAA}_SUCCESS`]: (state, action) => {
    return {
      ...action.payload,
      designatePAASaga: { isLoading: false, isError: false, isSuccess: true },
    };
  },
  [`${DESIGNATE_PAA}_STARTED`]: (state, action) => {
    return {
      ...state,
      designatePAASaga: { isLoading: true, isError: false, isSuccess: false },
    };
  },
  [`${DESIGNATE_PAA}_ERROR`]: (state, action) => {
    return {
      ...state,
      designatePAASaga: { isLoading: false, isError: true, isSuccess: false },
    };
  },
  [SET_JOB_FUNCTIONS]: (state, action) => {
    return {
      ...state,
      selectedJobFunctions: action.payload,
    };
  },
  [SET_API_LIST]: (state, action) => {
    return {
      ...state,
      apiListSelection: action.payload,
    };
  },
  [SET_API_USE_TEXT]: (state, action) => {
    return {
      ...state,
      apiUseText: action.payload,
    };
  },
  [SET_SELECTED_API_CODES]: (state, action) => {
    return {
      ...state,
      selectedApiCodes: action.payload,
    };
  },
  [SET_SELF_ATTESTATION_DONE]: (state, action) => {
    return {
      ...state,
      ...action.payload,
    };
  },
  [SET_PHONE_NUMBER]: (state, action) => {
    return {
      ...state,
      ...action.payload,
    };
  },
  [RESET_STATE]: (state, action) => {
    return { ...initialState };
  },
  [`${SUBMIT_TIN_REQUEST}_SUCCESS`]: (state, action) => {
    return {
      ...state,
      submitPATINSaga: {
        isLoading: false,
        isError: false,
        isSuccess: true,
      },
    };
  },
  [`${SUBMIT_TIN_REQUEST}_STARTED`]: (state, action) => {
    return {
      ...state,
      submitPATINSaga: { isLoading: true, isError: false, isSuccess: false },
    };
  },
  [`${SUBMIT_TIN_REQUEST}_ERROR`]: (state, action) => {
    return {
      ...state,
      submitPATINSaga: { isLoading: false, isError: true, isSuccess: false },
    };
  },
});
